import React from 'react'

import DoctorIndicationRegister from 'presentation/doctor/pages/DoctorIndicationRegister'
export default function makeDoctorIndicationRegister() {
  return <DoctorIndicationRegister />
}
